export default "__VITE_PUBLIC_ASSET__4b81dcc8__"